import React from 'react';
import { useLocation } from 'react-router-dom';
import Banner from './Banner';
import ProductImage from '../../../assets/products_img.webp';
import FactoryImage from '../../../assets/factory_img.webp';
import BananaImage from '../../../assets/banana_img.webp';
import NRCBImage from '../../../assets/nrcb_insti_img.webp';

const bannerConfig = {
  '/products': {
    image: ProductImage,
    title: 'Our Products',
    description: 'Browse a wide range of our offerings.',
  },
  '/aboutus': {
    image: NRCBImage,
    title: 'About Us',
    description: 'Learn more about our journey and values.',
  },
  '/contactus': {
    image: NRCBImage,
    title: 'Contact Us',
    description: 'Get in touch with our team.',
  },
  '/clients': {
    image: BananaImage,
    title: 'Our Entrepreneurs',
    description: 'Empowering innovators in banana enterprises.',
  },
  '/account': {
    image: FactoryImage,
    title: 'Welcome to Your Account',
  },
  '/myAccount/dashboard': {
    image: FactoryImage,
    title: 'Welcome to Your Dashboard',
  },
  '/privacy-policy': {
    image: FactoryImage,
    title: 'Privacy Policy',
  },
  '/return-and-refund-policy': {
    image: FactoryImage,
    title: 'Return And Refund Policy',
  },
};

function BannerSetting() {
  const location = useLocation();
  const pathname = location.pathname;
  const cleanPath = pathname.split('/')[1];

  const config = bannerConfig[pathname] ||
    Object.entries(bannerConfig).find(([route]) =>
      pathname.startsWith(route)
    )?.[1] || {
    image: BananaImage,
    title: `${cleanPath}`,
  };
  return <Banner {...config} />;
}

export default BannerSetting;
